import React, { useState } from "react";

// Araba parçaları — üst görünüm SVG diyagramı
export const OPERATIONS = [
  { key: "Kaporta", label: "Kaporta", color: "#ef4444", ring: "ring-rose-500", bg: "bg-rose-500" },
  { key: "Boya", label: "Boya", color: "#3b82f6", ring: "ring-blue-500", bg: "bg-blue-500" },
  { key: "Boyasız Onarım", label: "Boyasız Onarım", color: "#10b981", ring: "ring-emerald-500", bg: "bg-emerald-500" },
  { key: "Pasta Cila", label: "Pasta Cila", color: "#f59e0b", ring: "ring-amber-500", bg: "bg-amber-500" },
];

// Parça tanımları — daha büyük viewBox (500x900)
export const CAR_PARTS = [
  // ÖN TAMPON
  { key: "on_tampon", label: "Ön Tampon", short: "ÖN TAMPON", d: "M 110 25 Q 250 15 390 25 L 380 75 Q 250 65 120 75 Z", cx: 250, cy: 50 },
  // ÖN KAPUT
  { key: "on_kaput", label: "Ön Kaput", short: "ÖN KAPUT", d: "M 120 80 Q 250 75 380 80 L 380 195 L 120 195 Z", cx: 250, cy: 140 },
  // ÖN CAM (dekoratif)
  { key: "on_cam", label: "Ön Cam", short: "ÖN CAM", d: "M 130 200 L 155 240 L 345 240 L 370 200 Z", cx: 250, cy: 222, nonClickable: true },
  // ÖN SOL ÇAMURLUK
  { key: "on_sol_camurluk", label: "Ön Sol Çamurluk", short: "SOL ÖN\nÇAMURLUK", d: "M 68 90 L 115 90 L 115 235 L 68 235 Z", cx: 92, cy: 162 },
  // ÖN SAĞ ÇAMURLUK
  { key: "on_sag_camurluk", label: "Ön Sağ Çamurluk", short: "SAĞ ÖN\nÇAMURLUK", d: "M 385 90 L 432 90 L 432 235 L 385 235 Z", cx: 408, cy: 162 },
  // TAVAN (ortada, tıklanabilir)
  { key: "tavan", label: "Tavan", short: "TAVAN", d: "M 155 245 L 345 245 L 345 630 L 155 630 Z", cx: 250, cy: 437 },
  // ÖN SOL KAPI
  { key: "on_sol_kapi", label: "Ön Sol Kapı", short: "SOL ÖN\nKAPI", d: "M 68 245 L 150 245 L 150 430 L 68 430 Z", cx: 109, cy: 337 },
  // ÖN SAĞ KAPI
  { key: "on_sag_kapi", label: "Ön Sağ Kapı", short: "SAĞ ÖN\nKAPI", d: "M 350 245 L 432 245 L 432 430 L 350 430 Z", cx: 391, cy: 337 },
  // ARKA SOL KAPI
  { key: "arka_sol_kapi", label: "Arka Sol Kapı", short: "SOL ARKA\nKAPI", d: "M 68 435 L 150 435 L 150 625 L 68 625 Z", cx: 109, cy: 530 },
  // ARKA SAĞ KAPI
  { key: "arka_sag_kapi", label: "Arka Sağ Kapı", short: "SAĞ ARKA\nKAPI", d: "M 350 435 L 432 435 L 432 625 L 350 625 Z", cx: 391, cy: 530 },
  // SOL MARŞPİYEL (kapıların altında, dış bordür)
  { key: "sol_marspiyel", label: "Sol Marşpiyel", short: "SOL\nMARŞPİYEL", d: "M 45 300 L 65 300 L 65 575 L 45 575 Z", cx: 55, cy: 437 },
  // SAĞ MARŞPİYEL
  { key: "sag_marspiyel", label: "Sağ Marşpiyel", short: "SAĞ\nMARŞPİYEL", d: "M 435 300 L 455 300 L 455 575 L 435 575 Z", cx: 445, cy: 437 },
  // ARKA SOL ÇAMURLUK
  { key: "arka_sol_camurluk", label: "Arka Sol Çamurluk", short: "SOL ARKA\nÇAMURLUK", d: "M 68 630 L 115 630 L 115 775 L 68 775 Z", cx: 92, cy: 702 },
  // ARKA SAĞ ÇAMURLUK
  { key: "arka_sag_camurluk", label: "Arka Sağ Çamurluk", short: "SAĞ ARKA\nÇAMURLUK", d: "M 385 630 L 432 630 L 432 775 L 385 775 Z", cx: 408, cy: 702 },
  // ARKA CAM (dekoratif)
  { key: "arka_cam", label: "Arka Cam", short: "ARKA CAM", d: "M 130 635 L 155 675 L 345 675 L 370 635 Z", cx: 250, cy: 657, nonClickable: true },
  // BAGAJ KAPAĞI
  { key: "bagaj", label: "Bagaj Kapağı", short: "BAGAJ", d: "M 120 680 L 380 680 L 380 800 L 120 800 Z", cx: 250, cy: 740 },
  // ARKA TAMPON
  { key: "arka_tampon", label: "Arka Tampon", short: "ARKA TAMPON", d: "M 120 805 Q 250 820 380 805 L 390 855 Q 250 865 110 855 Z", cx: 250, cy: 835 },
  // SOL AYNA
  { key: "sol_ayna", label: "Sol Ayna", short: "SOL\nAYNA", d: "M 40 255 L 65 255 L 65 295 L 40 295 Z", cx: 52, cy: 275 },
  // SAĞ AYNA
  { key: "sag_ayna", label: "Sağ Ayna", short: "SAĞ\nAYNA", d: "M 435 255 L 460 255 L 460 295 L 435 295 Z", cx: 448, cy: 275 },
];

// Text yardımcı — çok satırlı label
function MultilineText({ x, y, text, ...props }) {
  const lines = text.split("\n");
  return (
    <text x={x} y={y} textAnchor="middle" dominantBaseline="middle" {...props}>
      {lines.map((line, i) => (
        <tspan key={`${i}-${line}`} x={x} dy={i === 0 ? -((lines.length - 1) * 7) : 14}>
          {line}
        </tspan>
      ))}
    </text>
  );
}

export default function CarDiagram({ selections = {}, onSelectPart }) {
  const [popoverPart, setPopoverPart] = useState(null);

  const getPartColor = (partKey) => {
    for (const op of OPERATIONS) {
      if (selections[`${partKey}__${op.key}`]) return op.color;
    }
    return "#e2e8f0";
  };

  const isSelected = (partKey) => {
    return OPERATIONS.some((op) => selections[`${partKey}__${op.key}`]);
  };

  const handlePartClick = (part) => {
    if (part.nonClickable) return;
    setPopoverPart({ key: part.key, label: part.label });
  };

  const handleOperationClick = (opKey) => {
    if (popoverPart && onSelectPart) {
      onSelectPart(popoverPart.key, popoverPart.label, opKey);
    }
    setPopoverPart(null);
  };

  return (
    <div className="relative">
      {/* Legend */}
      <div className="flex items-center justify-center gap-4 mb-3 flex-wrap">
        <span className="text-[11px] uppercase tracking-widest text-slate-500 font-semibold">
          Parçaya tıklayın → işlem türü seçin:
        </span>
        {OPERATIONS.map((op) => (
          <span key={op.key} className="inline-flex items-center gap-1.5 text-xs">
            <span className={`w-3 h-3 rounded-sm ${op.bg} border border-slate-300`} />
            <span className="text-slate-700 font-medium">{op.label}</span>
          </span>
        ))}
      </div>

      <div className="flex justify-center">
        <svg
          viewBox="0 0 500 890"
          className="w-full max-w-lg h-auto"
          data-testid="car-diagram"
        >
          {/* Yön etiketleri */}
          <text x="250" y="12" textAnchor="middle" fontSize="11" fill="#64748b" fontWeight="700" letterSpacing="2">
            ÖN
          </text>
          <text x="250" y="885" textAnchor="middle" fontSize="11" fill="#64748b" fontWeight="700" letterSpacing="2">
            ARKA
          </text>

          {/* Parça yolları */}
          {CAR_PARTS.map((part) => {
            const fill = part.nonClickable ? "#f8fafc" : getPartColor(part.key);
            const selected = isSelected(part.key);
            return (
              <g key={part.key}>
                <path
                  d={part.d}
                  fill={fill}
                  stroke={selected ? "#0f172a" : "#64748b"}
                  strokeWidth={selected ? "2.5" : "1.5"}
                  className={part.nonClickable ? "" : "cursor-pointer transition-all hover:brightness-95"}
                  onClick={() => handlePartClick(part)}
                  data-testid={`car-part-${part.key}`}
                  style={part.nonClickable ? { pointerEvents: "none" } : {}}
                >
                  <title>{part.label}</title>
                </path>
                <MultilineText
                  x={part.cx}
                  y={part.cy}
                  text={part.short}
                  fill={selected ? "#ffffff" : part.nonClickable ? "#94a3b8" : "#0f172a"}
                  fontSize={13}
                  fontWeight={selected ? 700 : 600}
                  fontFamily="system-ui, sans-serif"
                  style={{ pointerEvents: "none", userSelect: "none" }}
                />
              </g>
            );
          })}

          {/* Tekerlekler — dekoratif (kapı-marşpiyel arası) */}
          <rect x="20" y="145" width="20" height="55" rx="5" fill="#0f172a" opacity="0.55" pointerEvents="none" />
          <rect x="460" y="145" width="20" height="55" rx="5" fill="#0f172a" opacity="0.55" pointerEvents="none" />
          <rect x="20" y="680" width="20" height="55" rx="5" fill="#0f172a" opacity="0.55" pointerEvents="none" />
          <rect x="460" y="680" width="20" height="55" rx="5" fill="#0f172a" opacity="0.55" pointerEvents="none" />
        </svg>
      </div>

      {/* Popover */}
      {popoverPart && (
        <div
          className="fixed inset-0 z-50 flex items-center justify-center bg-black/40"
          onClick={() => setPopoverPart(null)}
          data-testid="operation-popover"
        >
          <div
            className="bg-white rounded-lg shadow-xl p-5 w-80 max-w-full"
            onClick={(e) => e.stopPropagation()}
          >
            <p className="text-[11px] uppercase tracking-widest text-slate-500 font-semibold">
              Seçilen Parça
            </p>
            <p className="font-display text-lg font-bold text-slate-900 mb-4">{popoverPart.label}</p>
            <p className="text-xs text-slate-600 mb-3">Yapılacak işlem türünü seçin:</p>
            <div className="space-y-2">
              {OPERATIONS.map((op) => (
                <button
                  key={op.key}
                  type="button"
                  data-testid={`op-btn-${op.key}`}
                  onClick={() => handleOperationClick(op.key)}
                  className={`w-full text-left px-4 py-2.5 rounded-md text-white font-semibold text-sm shadow-sm hover:opacity-90 transition-opacity ${op.bg}`}
                >
                  {op.label}
                </button>
              ))}
            </div>
            <button
              type="button"
              onClick={() => setPopoverPart(null)}
              className="w-full mt-3 text-xs text-slate-500 hover:text-slate-700 py-2"
            >
              Vazgeç
            </button>
          </div>
        </div>
      )}
    </div>
  );
}
